import React from "react";
import { Link } from "react-router-dom";

export default function SubscribeSuccess() {
	return (
		<div className="absolute-center">
			<h1>Success! Your subscription has been activated.</h1>
			<p>
				Manage your subscription from
				<b>
					<Link to="/my-account"> My Account</Link>
				</b>
				, or continue
				<b>
					<Link to="/trainer"> training</Link>
				</b>
				.
			</p>
		</div>
	);
}
